import { styled } from "@schaeffler-commerce/design-system";
import type { PageTemplateProps } from "./pageTemplateTypes";

/**
 * Migrated from styles/react/externalContent/misc.less
 * (.scha__sticky-navigation): sticky in-page navigation column offset below
 * the header.
 */
const StickyNavigation = styled("div")({
  position: "sticky",
  top: "30px",
});

/**
 * Slot-driven React template for the catch-all Static Content page whose
 * backend {@code metadata.templateUid} is {@code "StaticContentPageTemplate"}
 * (legacy {@code layout/staticContentPage.jsp}).
 *
 * Structure-copy parity of {@code staticContentPage.jsp}: a two-column flex
 * layout ({@code #st4content}) with the in-page navigation (20%, sticky) on the
 * left and the main content (80%) on the right. The {@code #st4content} id is
 * the typography hook styled by {@code st4Content.less}; the column flex
 * proportions come from the JSP inline styles (not LESS), so they are reproduced
 * here. The sticky nav column is handled by the StickyNavigation styled
 * component above.
 *
 * Catch-all static-content pages ({@code /static/legalnotice},
 * {@code /static/dataprivacy}) have no React island, so {@code body} is null and
 * ALL rendered content comes from the two page-scoped CMS slots:
 * {@code NavigationInPageSlot} and {@code ST4ContentSlot}.
 */
export function StaticContentPageTemplate({ slots, body }: PageTemplateProps) {
  return (
    <div className="d-flex" id="st4content">
      <div style={{ flex: "0 0 20%", marginRight: "16px" }}>
        <StickyNavigation className="scha__sticky-navigation">
          {slots.renderSlot("NavigationInPageSlot")}
        </StickyNavigation>
      </div>
      <div style={{ flex: "1 1 0%", marginLeft: "16px" }}>{slots.renderSlot("ST4ContentSlot")}</div>
      {body}
    </div>
  );
}
